<template>
  <div>
    <group-card title="SQL Auction Basket" icon="shopping_cart">
      <template slot="actions">
        <div class="local-lead-container">
          <div class="row-actions" style="justify-content: flex-start;">
            <md-switch
              :disabled="!!this.broker_postcode"
              :class="{'custom-disabled-switch': !!this.broker_postcode}"
              v-model="showLocalLead"
            >
              <p class="local-lead-label">Show Local Lead</p>
            </md-switch>
          </div>
          <div v-if="showRadius" class="row-actions">
            <label for="radius" class="local-lead-label"
            style="padding-right: 8px;">
              Postcode: {{ this.broker_postcode }}
              Radius : {{ this.radius }} km</label>
          </div>
        </div>
        <div class="header-actions">
          <div class="row-actions">
            <md-checkbox v-model="subscribed" v-if="auction_basket.isBroker">Subscribed</md-checkbox>
            <loading-icon-button @click="saveSubscribed" v-if="auction_basket.isBroker" tooltip="Save">
              save
            </loading-icon-button>
          </div>
          <div class="row-actions">
            <loading-icon-button @click="refreshAuctionBasket" tooltip="Refresh" :loading="loading">
              refresh
            </loading-icon-button>
            <loading-icon-text-button class="md-primary" @click="getTcModal" icon="assignment">
              Auction T&C
            </loading-icon-text-button>
          </div>
        </div>
      </template>

      <v-data-table
        class="auction-table"
        :headers="headers"
        :items="joinedAuctions"
        :mobile-breakpoint="0"
        :items-per-page="30"
        :footer-props="{
          itemsPerPageOptions: [20, 30]
        }"
      >
        <template v-slot:item="{ item }">
          <tr :style="{'background-color': item.tier === 'Live Auction' ? 'lavender' : '' }">
            <td>
              <div :class="['tag', {
                'local': checkIfLocalLead(item.post_code),
              }]">
                {{ checkLeadTag(item) }}
              </div>
            </td>
            <td>{{ item.id }}</td>
            <td>{{ item.grading_score }}</td>
            <td v-if="showAdminColumn">{{ item.tier }}</td>
            <td>
              <div class="action-button-wrapper">
                <md-button
                  class="md-primary md-raised"
                  :disabled="isExpired(item) && !item.need_allocation"
                  @click="showBidDialog(item)"
                  :class="['button bid-button', {
                    'hasBid': item.has_bid ,
                    'outBid': item.out_bid ,
                    'winning' : item.winning,
                    'pod_winning' : item.pod_winning,
                    'isNotActive' : (item.is_active == 0) ? true : false
                  }]"
                >
                  {{ isBuyNow(item.tier) ? 'Buy Now' : 'Bid' }}
                </md-button>
                <div class="action-button-dot" v-if="item.need_allocation">Assign</div>
              </div>
            </td>
            <td>{{ item.current_bid }}</td>
            <td>{{ item.sql_minimum_bid }}</td>
            <td>{{ getTimeLeft(item.expired_time) }}</td>
            <td>{{ item.post_code }}</td>
            <td>{{ item.employment_status }}</td>
            <td>{{ item.visa_status }}</td>
            <td>{{ item.address_ownership }}</td>
            <td>{{ item.loan_type }}</td>
            <td>{{ item.asset_type }}</td>
            <td>
              <md-button
                class="md-primary md-raised button"
                @click="showVedaReportDialog(item)"
                v-if="item.veda_score"
                style ="padding: 0"
              >
                {{ item.veda_score }}
              </md-button>
            </td>
            <!-- <td>
              <md-icon :class="['ba-check', {
                  'has_ba_options': item.ba_options ,
                }]">assured_workload
              </md-icon>
            </td> -->
            <td>
              <md-icon :class="['doc-check', {
                  'has_documents': item.documents ,
                }]">request_quote
              </md-icon>
            </td>
            <td><md-icon :class="`voi_${item.voi.grade}`" v-if="item.voi.grade">attach_money</md-icon></td>
            <td>{{ item.naf }}</td>
            <td v-if="showAdminColumn">
              <md-button @click="runTheProcess(item)" >
                {{ findProcessLabel(item.tier) }}
              </md-button>
            </td>
          </tr>
        </template>
      </v-data-table>
    </group-card>

    <md-dialog :md-active.sync="bidDialog" :md-click-outside-to-close="!needAllocation">
      <div class="dialog-wrapper">
        <div class ="top-dialog">
          <h4 class="font-bold" v-if="needAllocation">Assign Lead To Broker</h4>
          <md-dialog-title v-if="!isBuyNow(selectedAuctionTier)">
            Current Bid: ${{ this.currentBidAmount }}
          </md-dialog-title>
          <md-table md-card>
            <md-table-toolbar>
              <div class="md-toolbar-section-start">
                <h1 class="md-title">
                  {{ isBuyNow(this.selectedAuctionTier) ? 'Buy Now Fee' : 'Next Bid' }}:
                  ${{ isBuyNow(this.selectedAuctionTier) ? this.bidAmount : this.bidAmount }}
                </h1>
              </div>
              <div v-if="this.selectedAuctionTier!=='Distribution'" class="md-toolbar-section-end">
                <h2 class="md-title">Time Left: {{ this.currentTimeLeft }}</h2>
              </div>
            </md-table-toolbar>
            <div
              v-if="needAllocation"
              class="md-layout md-gutter lead-allocation-wrapper"
              style="width: auto;"
            >
              <v-autocomplete v-model="leadAllocation" id="leadAllocation" :items="podUserOptions" label="Assign Lead To Broker" class="z-index-999" dense></v-autocomplete>
            </div>
            <ValidationObserver v-slot="{invalid, errors}">
            <md-toolbar class="md-transparent" md-elevation="0" v-if="allowToBid && !isBuyNow(selectedAuctionTier)">
                <div class="md-toolbar-section-start">
                  <validated-number-input
                    v-model="maxBid"
                    prefix="$"
                    integer
                  />
                </div>
                <div class="md-toolbar-section-end">
                  <md-button :disabled="invalid" class="md-primary" @click="setMaxBid">Set Max</md-button>
                </div>
            </md-toolbar>
            </ValidationObserver>
          </md-table>

          <md-dialog-actions>
            <md-button v-if="!needAllocation" class="md-primary" @click="bidDialog = false">Close</md-button>
            <div class="bid-buttons" v-if="needAllocation">
              <md-button class="md-primary"
                @click="submitLeadAllocationBid"
                :disabled="buying"
              >
                <span v-if="buying">
                  <i class="fa fa-spinner fa-spin"></i> Processing...
                </span>
                <span v-else>Submit</span>
              </md-button>
            </div>
            <div class="bid-buttons" v-if="allowToBid">
              <md-button class="md-primary"
                @click="submitBuyNow"
                v-if="isBuyNow(this.selectedAuctionTier)"
                :disabled="buying"
              >
                <span v-if="buying">
                  <i class="fa fa-spinner fa-spin"></i> Processing...
                </span>
                <span v-else>Buy Now</span>
              </md-button>
              <md-button class="md-primary" @click="submitBid" v-else>Bid</md-button>
            </div>
          </md-dialog-actions>
        </div>
      </div>
    </md-dialog>

    <md-dialog :md-active.sync="leadAllocationDialog" :md-click-outside-to-close="false">
      <div class="top-dialog">
        <h4 class="font-bold">Assign Lead To Broker</h4>
        <md-table md-card>
          <div
            class="md-layout md-gutter lead-allocation-wrapper"
            style="width: auto;"
          >
            <v-autocomplete v-model="leadAllocation" id="leadAllocation" :items="podUserOptions" label="Assign Lead To Broker" class="z-index-999" dense></v-autocomplete>
          </div>
        </md-table>
        <md-dialog-actions>
          <div class="bid-buttons">
            <md-button class="md-primary" @click="submitLeadAllocation" :disbaled="buying">{{ buying ? "Processing..." : "Submit" }}</md-button>
          </div>
        </md-dialog-actions>
      </div>
    </md-dialog>

    <md-dialog :md-active.sync="vedaReportDialog">
      <div class="vedaReportWrapper">
        <veda-summary :veda-report="veda_report" :showFullReportButton="false" :showPerfectScoreButton="false" />
      </div>
    </md-dialog>

    <md-dialog-alert
      :md-active.sync="alert_dialog.show"
      :md-title="alert_dialog.title"
      :md-content="alert_dialog.content"
    />

    <md-dialog :md-active.sync="tcDialog" :md-click-outside-to-close="false">
      <md-dialog-content>
        <p class="message-height side-header font-bold"> Market Place Terms and Conditions</p>
        <p class="message-height">
          <ul class="message-ul">
            <li>Ausloans will source applications from various sources and lead generators</li>
            <li>Full customer declared application will be completed</li>
            <li>Varying Supporting docs will be collected</li>
            <li>1 or more lending options will be available including a lessor amount or varied product</li>
            <li>no red traffic light assessments will be distributed</li>
            <li>cross file references are accessed , possible matches are not</li>
            <li>Banking if requested is not assessed</li>
            <li>Income is not verified</li>
          </ul>
        </p>
        <p class="message-height side-header font-bold">SLA Knockouts</p>
        <p class="message-height">
          <ul class="message-ul">
            <li>Student/ Unemployed</li>
            <li>Travel/ Student Visa</li>
            <li>Under 18 or over 80 years old</li>
            <li>Payday Enquires >= 3</li>
            <li>Financial Defaults >= 7500</li>
            <li>Non-Financial Defaults >= 10000 within the last 12 months</li>
            <li>CCR Repayment history > 2</li>
          </ul>
        </p>
        <p class="message-height side-header font-bold">Support</p>
        <p class="message-height">
          <ul class="message-ul">
            <li>Technical – support ticket via zink</li>
            <li>Outside of the specified above criteria – <a href="mailto:callmanager@ausloans.com.au"> callmanager@ausloans.com.au </a></li>
            <li>Access / how to use – <a href="mailto:neil.crotty@ausloans.com.au"> neil.crotty@ausloans.com.au </a></li>
          </ul>
        </p>
        <div class="action-buttons-cover">
          <md-dialog-actions>
              <md-button class="md-primary" @click="closeTcModal">Confirm</md-button>
          </md-dialog-actions>
        </div>
      </md-dialog-content>
    </md-dialog>

    <md-dialog :md-active.sync="postcodeDialog"  :md-click-outside-to-close="false">
      <md-dialog-title>Please enter your postcode to access Local Lead feature</md-dialog-title>
      <md-dialog-content>
        <!-- Postcode -->
        <validated-number-input class="md-layout-item md-small-size-100 md-size-10"
          label="Postcode" v-model="postcodeInput"
          integer
          :minLength=4
          :maxLength=4
          :errormsg="postcodeInput && postcodeInput.length > 4 ?
            'Australia postcode accept only 4 digits' :
            'Please enter the correct information.'"
          >
        </validated-number-input>
        <md-dialog-actions>
          <md-button class="md-primary" @click="confirmToSubmitPostcode">Confirm</md-button>
          <md-button class="md-primary" @click="closePostcodeModal">Close</md-button>
        </md-dialog-actions>
      </md-dialog-content>
    </md-dialog>

    <md-dialog-confirm
      :md-active.sync="confirm_dialog.show"
      :md-title="confirm_dialog.title"
      :md-content="confirm_dialog.content"
      :md-confirm-text="confirm_dialog.confirm_text"
      :md-cancel-text="confirm_dialog.cancel_text"
      @md-confirm="confirm_dialog.action"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {GroupCard} from "@/components";
import LoadingIconButton from '@/components/LoadingIconButton';
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import VedaSummary from '@/components/ApplicationSummary/VedaSummary.vue';
import ValidatedNumberInput from "../components/ValidatedInput/ValidatedNumberInput";
import filters from "@/components/utils/filters";
import ValidatedSelectInput from "../components/ValidatedInput/ValidatedSelectInput";
import moment from 'moment';

export default {
  components: {
    GroupCard,
    LoadingIconButton,
    LoadingIconTextButton,
    VedaSummary,
    ValidatedNumberInput,
    ValidatedSelectInput
  },
  props: ['onAuctionPage'],
  data() {
    return {
      showDistribution: false,
      bidAmount: 0,
      minAmount: 0,
      currentBidAmount: 0,
      currentTimeLeft: null,
      currentExpiredTime: null,
      allowToBid:true,
      choosenAuctionId: null,
      currentTime: new Date().getTime(),
      bidDialog: false,
      vedaReportDialog: false,
      alert_dialog: {
        show: false,
        content: "",
        title: ""
      },
      tcDialog: false,
      leadAllocationDialog: false,
      subscribed: false,
      loading: false,
      buying: false,
      radius:30,
      timer: '',
      timeLeftTimer: '',
      maxBid: 0,
      selectedAuctionTier: '',
      headers: [
        { text: 'Tag', align: 'center', value: 2, sortable: false },
        { text: 'ID', align: 'center', value: 'id' },
        { text: 'Grading Score', align: 'center', value: 'grading_score' },
        { text: 'Action', align: 'center', value: 1, sortable: false },
        { text: 'Bid', align: 'center', value: 'current_bid', sortable: false },
        { text: 'Starting Price', align: 'center', value: 'sql_minimum_bid', sortable: false },
        { text: 'Time Left', align: 'center', value: 'expired_time', sortable: false },
        { text: 'Postcode', align: 'center', value: 'post_code', sortable: false },
        { text: 'Employment', align: 'center', value: 'employment_status', sortable: false },
        { text: 'Visa', align: 'center', value: 'visa_status', sortable: false },
        { text: 'Residency', align: 'center', value: 'address_ownership', sortable: false },
        { text: 'Loan Type', align: 'center', value: 'loan_type', sortable: false },
        { text: 'Asset Type', align: 'center', value: 'asset_type', sortable: false },
        { text: 'Veda', align: 'center', value: 'veda_score', sortable: false },
        //{ text: 'BA', align: 'center', value: 'ba_options', sortable: false },
        { text: 'Documents', align: 'center', value: 'documents', sortable: false },
        { text: 'VOI', align: 'center', value: 'voi', sortable: false },
        { text: 'NAF', align: 'center', value: 'naf', sortable: false },
      ],
      isNewVersion: 'No',
      showLocalLead: false,
      showRadius: false,
      showTagColumn: false,
      showAdminColumn: false,
      showRadius: false,
      uniqueLocalPostcodes: null,
      postcodeInput: null,
      postcodeDialog: false,
      confirm_dialog: {
        show: false,
        content: "",
        title: "",
        confirm_text: "Confirm",
        cancel_text: "Cancel",
        action: () => {}
      },
      leadAllocation: this.$store.state.user.id,
      requestPayload: null,
      needAllocation: false
    }
  },
  computed: {
    ...mapGetters([
      "auction_basket",
      "distribution_basket",
      "auction",
      "broker_postcode",
      "broker_radius",
      "veda_report",
      "user",
      "properties",
      "userHasRole"
    ]),
    joinedAuctions() {
      let ab = this.auction_basket.applications;
      try {
        if (this.showDistribution) {
          let db = this.distribution_basket.applications;
          return ab.concat(db);
        }
        return ab;
      } catch(error) {
        console.log(error);
      }
    },
    isPodOwner() {
      let userPods = this.$store.state.user.user_pods;

      let ownedPods = userPods.filter((item) => {
        return item.is_pod_owner;
      });

      return ownedPods.length;
    },
    podUserOptions() {
      let data = [];
      const userPods = this.$store.state.user.user_pods;

      userPods && Array.isArray(userPods) && userPods.forEach(pod => {
        if (pod.is_pod_owner) {
          data.push({
            header: pod.name
          });

          pod.users && Array.isArray(pod.users) && pod.users.forEach(user => {
            data.push({
              text: `${user.first_name} ${user.last_name}${this.$store.state.user.id === user.id ? ' (You)' : ''}`,
              value: user.id,
              disabled: !user.same_tier
            });

          });
        }
      });
     
      return data;
    }
  },
  methods: {
    ...filters,
    isBuyNow(tier) {
      return tier === 'Diamond' || tier === 'Platinum' || tier === 'Live Auction' || tier === 'Distribution' || tier === 'Local Lead';
    },
    findProcessLabel(tier) {
      if (tier == 'Distribution') {
        return 'Move to SQL';
      } else {
        return 'Close'
      }
    },
    async refreshAuctionBasket() {
      if (this.onAuctionPage) {
        try {
          this.loading = true;
          const result = await this.$store.dispatch('fetch_auction_basket');
          if (!result['success']) {
            this.cancelTimer();
            this.showDialogPopup(
              "Error",
              result['data']['error'] ?? "Something went wrong while fetch Auctions. Please try again later.",
            );
          }
          if (this.showDistribution) {
            const resultDistrib = await this.$store.dispatch('fetch_distribution_auction');
            if (!resultDistrib['success']) {
              this.showDialogPopup(
                "Error",
                resultDistrib['data']['error'] ?? "Something went wrong while fetch Distributions. Please try again later.",
              );
            }
          }
        } catch (err) {
          console.log(err);
        } finally {
          this.loading = false;
        }
      }
    },
    getTcModal(){
      this.tcDialog = true;
    },
    closeTcModal(){
      this.tcDialog = false;
    },
    getPostcodeModal(){
      this.postcodeDialog = true;
    },
    closePostcodeModal(){
      this.showLocalLead = false;
      this.postcodeDialog = false;
    },
    async saveSubscribed() {
      try {
        let response = await axios.post('/api/v1/auction/subscribe', { subscribed : this.subscribed });
        if (response.data.subscribed == true) {
          this.showDialogPopup("","You have subscribed to receive notification about new actions.")
        } else {
          this.showDialogPopup("","You have unsubscribed to receive notification about new actions.")
        }
      } catch (err) {
        this.showDialogPopup("","You are not broker.")
        console.log(err);
      }
    },
    getTimeLeft(expired_time) { //Calculating time left
      if (expired_time && this.onAuctionPage) {
        let timeLeft = expired_time - this.currentTime;
        //If time left is < 0 or the auction is no longer active
        if (timeLeft <= 0) {
          return "Expired!";
        }
        return `${(Math.floor(timeLeft/60000)).toFixed()} m ${((timeLeft/1000)%60).toFixed()} s `;
      }
      return '';
    },
    async showBidDialog(item) {
      this.allowToBid = true;
      this.selectedAuctionTier = item.tier;      
      if (this.selectedAuctionTier == 'Distribution') {
        this.getBuyNowFeeDistribution(item.tier, item.grading_score);
        this.choosenAuctionId = item.id;
      } else {
        if (this.getTimeLeft(item.expired_time) == "Expired!") {
          this.allowToBid = false;
          this.needAllocation = item.need_allocation;
          this.leadAllocation = this.$store.state.user.id;
        } else {
          this.needAllocation = false;
        }
        this.currentExpiredTime = item.expired_time;
        try {
          await this.$store.dispatch('fetch_highest_bid', { auction_id: item.id });
          this.maxBid = this.auction.max_bid ? this.auction.max_bid.amount : 0;
          // Comment out- Using minimum bid from backend
          //this.getMinimumBid(item.grade, item.tier, item.grading_score);
          this.minAmount = parseInt(item.sql_minimum_bid);
          this.currentBidAmount = this.auction.bid ? parseInt(this.auction.bid.amount) : 0;
          this.minAmount = this.auction.bid ? (parseInt(this.auction.bid.amount) + 10) : this.minAmount;
          this.bidAmount = this.minAmount;
          this.choosenAuctionId = item.id;
          this.currentTimeLeft = this.getTimeLeft(item.expired_time);
        } catch (err) {
          console.log(err);
        }
      }
      this.bidDialog = true;
    },
    getBuyNowFeeDistribution(tier = 'Distribution', grading_score = 1) {
      if (tier == "Distribution") {
        let billingAmount = this.properties.auction_service_billings[tier]['buy_now'] ?? 240;
        this.minAmount = billingAmount;
        this.bidAmount = this.minAmount;
      }
      return;
    },
    isCurrentExpiredTimeExpired () {
      if (this.getTimeLeft(this.currentExpiredTime) == "Expired!") {
        this.showDialogPopup(
          "Expired!",
          "The auction has expired!"
        );
        return true;
      }
      return false;
    },
    isCurrentTimeLeft () {
      if (this.currentTimeLeft == 'Expired!') {
        this.showDialogPopup(
          "Expired!",
          "The auction has expired!"
        );
        return true;
      }
      return false;
    },
    isLessThanMinAmount (amount, error_messages) {
      if (parseInt(amount) < this.minAmount) {
        this.showDialogPopup(
          error_messages["title"],
          error_messages["message"]
        );
        return true;
      }
      return false;
    },
    async submitBid() {
      if (this.isCurrentExpiredTimeExpired()) return;
      if (this.isCurrentTimeLeft()) return;

      const less_error = {
        "title": "Bid too low",
        "message": "Please place the bid again."
      };
      if (this.isLessThanMinAmount(this.bidAmount, less_error)) return;

      if (!Number.isInteger(parseInt(this.bidAmount))) {
        this.showDialogPopup(
          "Incorrect Input",
          "Please place the bid again."
        );
        return;
      }

      await this.submitBidToZink(this.choosenAuctionId, this.bidAmount, false, false);
    },
    async setMaxBid() {
      if (this.isCurrentExpiredTimeExpired()) return;
      if (this.isCurrentTimeLeft()) return;

      if (this.maxBid % 10 != 0) {
        this.showDialogPopup("", "Bid must be divisible by 10.");
        return;
      }

      const less_error = {
        "title": "Max bid too low",
        "message": "Please place the max bid again."
      };
      if (this.isLessThanMinAmount(this.maxBid, less_error)) return;

      if (parseInt(this.maxBid) - this.minAmount >= 500) {
        this.showDialogPopup(
          "Max bid too high",
          "Max bid is capped at $500 over min bid."
        );
        return;
      }

      await this.submitBidToZink(this.choosenAuctionId, this.maxBid, true, false)
    },
    async submitBuyNow () {
      if (this.selectedAuctionTier === 'Distribution') {
        await this.submitBidToZink(this.choosenAuctionId, this.bidAmount, false, false, this.selectedAuctionTier);
      } else {
        if (this.isCurrentExpiredTimeExpired()) return;
        if (this.isCurrentTimeLeft()) return;

        const less_error = {
          "title": "Bid too low",
          "message": "Please place the bid again."
        };
        if (this.isLessThanMinAmount(this.bidAmount, less_error)) return;

        await this.submitBidToZink(this.choosenAuctionId, this.bidAmount, false, true);
      }
    },
    async submitBidToZink (auctionId, amount, is_max_bid = false, is_buy_now = false, selected_tier = 'Action') {
      this.buying = true;
      try {
        let response;
        if (selected_tier === 'Distribution')
        {
          response = await this.$store.dispatch('buy_auction', {
            auction_id: auctionId,
            bid_amount: amount,
          });
        } else {
          response = await this.$store.dispatch('submit_bid', {
            auction_id: auctionId,
            bid_amount: amount,
            is_max_bid: is_max_bid,
            is_buy_now: is_buy_now,
            is_new: this.isNewVersion,
            is_pod_owner: this.isPodOwner
          });
        }
        this.bidDialog = false;

        if (this.isPodOwner && response.message === "Lead allocation required.") {
          this.requestPayload = {
            auction_id: auctionId,
            bid_amount: amount,
            is_max_bid: is_max_bid,
            is_buy_now: is_buy_now,
            is_new: this.isNewVersion,
          };
          this.leadAllocation = this.$store.state.user.id;
          this.leadAllocationDialog = true;
        } else {
          let message = response.message;
          if (response.link) {
            message += `<br/> Please click this arrow to view the application <a href="${response.link}" target="_blank">`;
            message += `<i class="md-icon md-icon-font md-theme-default" style="font-weight: 900; color: blue;">
                          arrow_forward
                        </i></a>`;
          }
          this.showDialogPopup(
            response.title,
            message
          );
          this.refreshAuctionBasket();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.buying = false;
      }
    },
    async submitLeadAllocation() {
      this.buying = true;
      try {
        this.requestPayload["user_id"] = this.leadAllocation;

        const response = await this.$store.dispatch('submit_bid', this.requestPayload);

        if (response.message === "Purchase successful.") {
          this.leadAllocation = this.$store.state.user.id;
          this.leadAllocationDialog = false;
        }

        this.showDialogPopup(
          response.title,
          response.message
        );
        this.refreshAuctionBasket();
      } catch (err) {
        console.log(err);
      } finally {
        this.buying = false;
      }
    },
    async submitLeadAllocationBid() {
      this.buying = true;

      try {
        let response = null;
        if (this.isBuyNow(this.selectedAuctionTier)) {
          response = await this.$store.dispatch('submit_bid', {
              auction_id: this.choosenAuctionId,
              bid_amount: this.currentBidAmount,
              is_max_bid: false,
              is_buy_now: true,
              is_new: this.isNewVersion,
              user_id: this.leadAllocation
            });

            if (response.message === "Purchase successful.") {
              this.bidDialog = false;
            }
        } else {
          response = await this.$store.dispatch('submit_lead_allocation', {
            auction_id: this.choosenAuctionId,
            user_id: this.leadAllocation
          });

          if (response.message === "Lead has been allocated successfully.") {
            this.bidDialog = false;
          }
        }

        this.showDialogPopup(
          response.title,
          response.message
        );
        this.refreshAuctionBasket();
      } catch (err) {
        console.log(err);
      } finally {
        this.buying = false;
      }
    },
    async showVedaReportDialog(item) {
      try {
        await this.$store.dispatch("fetch_veda_report", {
          loan_application_id: item.loan_application_id,
          is_auction_veda: 1
        });
        this.vedaReportDialog = true;
      } catch(error) {
        console.log(error);
      }
    },
    showDialogPopup(title, message) {
      this.alert_dialog.title = title;
      this.alert_dialog.content = message;
      this.alert_dialog.show = true;
    },
    showConfirmDialog (content, action, buttonOptions = {}, show = true) {
      this.confirm_dialog.content = content
      this.confirm_dialog.confirm_text = buttonOptions.confirm ?? "Confirm"
      this.confirm_dialog.cancel_text =  buttonOptions.cancel ?? "Cancel"
      this.confirm_dialog.action = action
      this.confirm_dialog.show = show
    },
    async runTheProcess(item) {
      try {
        let response = '';
        if (item.tier == 'Distribution') {
          response = await this.$store.dispatch('move_to_sql', {
            auction_id: item.id,
          });
        } else {
          response = await this.$store.dispatch('process_the_auction', {
            auction_id: item.id,
          });
        }

        if (response) {
          this.showDialogPopup (
            response.title,
            response.message
          );
        } else {
          this.showDialogPopup (
            'Response is empty',
            'Something went wrong'
          );
        }

        this.refreshAuctionBasket();
      } catch (err) {
        console.log(err);
      }
    },
    getMinimumBid(grade = "Grade A", tier = 'Silver', grading_score = null) { //Default grading_score if not yet fetch
      let billingAmount = this.properties.auction_service_billings[tier]["Grade A"];
      this.minAmount = billingAmount ? (billingAmount * grading_score) : 150;

      if (this.minAmount < 49) {
        //Set minimum bid amount to $49 if grading_score is negative
        this.minAmount = 49;
      } else if (this.minAmount >= 306 && grade == "Live Auction") {
        //Set maximum bid amount to $306 if grading_score is over 1530 && Live Auction
        this.minAmount = 306;
      }  else if (this.minAmount >= 290 && grade != "Live Auction") {
        //Set maximum bid amount to $290 if grading_score is over 1450
        this.minAmount = 290;
      }

      this.bidAmount = this.minAmount;
      return;
    },
    cancelTimer() {
      clearInterval(this.timer);
      clearInterval(this.timeLeftTimer);
    },
    confirmToSubmitPostcode() {
      if (this.postcodeInput == null || (this.postcodeInput.length !== 4)) {
        this.closePostcodeModal();
        this.showLocalLead = false;
        this.showDialogPopup(
          "Wrong Postcode",
          "Please enter correct postcode",
        )
        return;
      }
      const dialogContent = 'Do you confirm that this is your correct postcode?';
      this.showConfirmDialog(dialogContent, () => this.updateBrokerPostcode() , { confirm: 'Yes', cancel: 'No' })
    },
    async updateBrokerPostcode() {
      try {
        const payload = {
          user_id: this.user.id,
          postcode: this.postcodeInput,
        }
        let response = await axios.post('/api/v1/auction/update_broker_postcode', payload);
        if (response.data != null) {
          this.$store.commit('set_broker_postcode', response.data.postcode);
        }
        this.showDialogPopup(
          "",
          "Update postcode successfully!",
        );
        this.searchBrokerPostcodes();
        this.showRadius = true;
        this.headers.unshift({ text: 'Tag', align: 'center', value: 2, sortable: false });
      } catch (err) {
        console.log(err);
        this.showDialogPopup(
          "Error",
          "Please try again later!",
        )
      } finally {
        this.postcodeDialog = false;
      }
    },
    checkIfLocalLead(postcode) {
      if (this.broker_postcode == null || this.uniqueLocalPostcodes == null || postcode == null) {
        return false;
      }
      return this.uniqueLocalPostcodes.includes(parseInt(postcode));
    },
    checkLeadTag(lead) {
      if (lead == null) {
        return "";
      }

      if (lead.tier == "Live Auction" && this.checkIfLocalLead(lead.post_code)) {
        return "LIVE / LOCAL";
      }

      if (lead.tier == "Live Auction") {
        return "LIVE";
      }

      if (lead.tier == "Distribution" && this.checkIfLocalLead(lead.post_code)) {
        return "PARTNER / LOCAL";
      }

      if (lead.tier == "Distribution") {
        return "PARTNER";
      }

      if (this.checkIfLocalLead(lead.post_code)) {
        return "LOCAL";
      }

      return "";
    },
    async searchBrokerPostcodes() {
      try {
        let response = await axios.post('/api/v1/auction/broker_postcode_search', {
          radius: this.radius,
          postcode: this.broker_postcode,
        });
        this.uniqueLocalPostcodes = response.data.postcodes;
      } catch (err) {
        console.log(err);
      }
    },
    isExpired(item) {
        if (!item || !item.expires_at) return false;

        // Parse expires_at as UTC and compare with current UTC time
        return moment.utc().isAfter(moment.utc(item.expires_at));
    }
  },
  watch: {
    showLocalLead: function () {
      if (this.showLocalLead) {
        if (this.broker_postcode == null) {
          this.getPostcodeModal();
        } else {
          this.showRadius = true;
        }
      } else {
        if (this.showRadius) {
          this.showRadius = false;
        }
      }
    },
  },
  filters: {
    ...filters,
  },
  async created() {
    try {
      let response = await axios.get('/api/v1/user/get_service_subscriptions');
      if (response.data.includes("Distribution")) {
        this.showDistribution = true;
      }
    } catch(error) {
      console.log(error);
    }

    try {
      await this.$store.dispatch('fetch_auction_basket');

      if (this.showDistribution) {
        await this.$store.dispatch('fetch_distribution_auction');
      }

      if (this.auction_basket.subscribe_status == 1) {
        this.subscribed = true;
      }

      if (this.auction_basket.postcode != null) {
        this.$store.commit('set_broker_postcode', this.auction_basket.postcode);
        this.$store.commit('set_broker_radius', this.auction_basket.radius);
        this.radius = this.auction_basket.radius;
        this.showLocalLead = true;
      }

    } catch (err) {
      console.log(err);
    }

    if (this.broker_postcode != null) {
      this.searchBrokerPostcodes();
    }
    // setup header based on role
    if (this.userHasRole('super-admin')) {
      // Add Tier
      const scoreIndex = this.headers.findIndex(header => header.text === 'Grading Score');
      if (scoreIndex > -1) {
        this.headers.splice(scoreIndex + 1, 0, { text: 'Tier', align: 'center', value: 'tier', sortable: false });
      }
      // Add Process
      const nafIndex = this.headers.findIndex(header => header.text === 'NAF')
      if (nafIndex > -1) {
        this.headers.splice(nafIndex + 1, 0, { text: 'Action', align: 'center', value: 3, sortable: false });
      }

      if (scoreIndex > -1 && nafIndex > -1) {
        this.showAdminColumn = true;
      }
    }
    this.timer = setInterval(this.refreshAuctionBasket, 4000);
    this.timeLeftTimer = setInterval(() => {
      this.currentTime = Date.now();
    }, 1000);
    this.isNewVersion = 'Yes';
  },
  beforeDestroy() {
    this.cancelTimer();
  },
  async beforeCreate() {
    const params = {
      types: [
        'auction_service_billings',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/md-custom/_ausloans-colors.scss";
::v-deep i.voi_gold {
  color: DarkGoldenRod !important;
}

::v-deep i.voi_silver {
  color: Silver !important;
}

::v-deep i.voi_bronze {
  color: #cd7f32 !important;
}
.auction-table {
  margin: 0;
  overflow: scroll;
  overflow-y: hidden;
}

.custom-disabled-switch {
  opacity: 0.5;
  pointer-events: none;
}

.live-auction-row {
  background-color: lavender !important;
}

.action-buttons-cover{
  float: left;
  margin-top: 50px;
  width: 100%;
}

.message-ul{
  padding-left: 100px;
  padding-right: 100px;
}

.side-header{
  font-size: 1.25rem;
}

.message-height{
  line-height: 2rem;
}
.font-bold{
  font-weight: bold;
}

.dialog-wrapper {
  height: fit-content;
}

.top-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: auto;
  width: auto;
  min-width: 20vw;
  max-width: 40vw;
  padding: 20px;
  form {
    div {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 2px;
    }
  }
}

.vedaReportWrapper {
  min-width: 60vw;
}

.button {
  padding: 0;
  margin: 0;
  max-height: 27px;
  display: flex;
  align-items: center;
}

.action-button-wrapper {
  position: relative;
  display: inline-block;
}

.action-button-dot {
  width: fit-content;
  top: -8px;
  right: -15px;
  padding: 1px 5px;
  border-radius: 999px;
  position: absolute;
  background: red;
  color: white;
  font-size: x-small;
  font-weight: bold;
  animation: blinker 1s cubic-bezier(.5, 0, 1, 1) infinite alternate;  
}

@keyframes blinker {  
  from { opacity: 1; }
  to { opacity: 0.7; }
}

.bid-button {
  padding: 0;

  &.isNotActive {
    background-color: rgb(71, 67, 67) !important;
  }

  &.outBid {
    background-color: red !important;
  }

  &.pod_winning {
    background-color: rgba(248, 232, 82, 0.808) !important;
  }

  &.winning {
    background-color: rgb(23, 179, 23) !important;
  }
}

.tag {
  color: dodgerblue;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  &.local {
  }
}

.ba-check {
  color: rgb(71, 67, 67);

  &.has_ba_options {
    color: rgb(23, 179, 23)  !important;
  }
}

.doc-check {
  color: rgb(71, 67, 67);

  &.has_documents {
    color: rgb(23, 179, 23) !important;
  }
}

.bid-buttons {
  margin-left: 8px;
}

.row-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.local-lead-container {
  display: flex;
  flex-direction: column;
  margin-right: 5rem;
}

.local-lead-label {
  font-weight: 600;
  color: rgba(0,0,0,.6);
}

.radius-select {
  width: 50px;
  padding: 5px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px
}

.lead-allocation-wrapper {
  margin-top: 10px;
  padding: 0 30px;
}

.z-index-999 {
  z-index: 999;
}

@media screen and (max-width: 768px) {
  .header-actions {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: space-evenly;
    left: 25vw;
    top: 70px;
  }

  .row-actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: center;
  }

  .top-dialog {
    max-width: 90vw;
  }

  .dialog-wrapper {
    height: 100vh;
    overflow-x: auto;
  }

  .auction-table {
    margin-top: 120px;
  }
}

@media (min-width: 667px) and (max-width: 1024px) and (orientation: landscape) {
  .dialog-wrapper {
    height: 100vh;
    overflow-x: auto;
  }
}
</style>
